// sub-navbar.config.ts
export interface SubNavbarConfig {
    baseUrl: string;
    label: string;
    parent?: string;
    detailRegex?: RegExp;
    detailLabel?: string;
}

/**
 * Array of sub-navbar configurations
 * @returns Array of sub-navbar configurations
 */
export const SUB_NAVBAR_CONFIG: SubNavbarConfig[] = [
    {
        baseUrl: '/dashboard',
        label: 'Dashboard',
    },
    {
        baseUrl: '/licenses',
        label: 'Licenses',
        detailRegex: /\/licenses\/(\d+)/,
        detailLabel: 'Licenses',
    },
    {
        baseUrl: '/hosts',
        label: 'Hosts',
        detailRegex: /\/hosts\/(\d+)/,
        detailLabel: 'Single Host',
    },
    {
        baseUrl: '/dealers',
        label: 'Dealers',
    },
    {
        baseUrl: '/media-library',
        label: 'Media Library',
        detailRegex: /\/media-library\/([a-zA-Z0-9_-]+)/,
        detailLabel: 'Single Media',
    },
    {
        baseUrl: '/users',
        label: 'Users',
        detailRegex: /\/users\/([a-zA-Z0-9_-]+)/,
        detailLabel: 'Single User',
    },
    {
        baseUrl: '/advertisers',
        label: 'Advertisers',
        detailRegex: /\/advertisers\/(\d+|create)/,
    },
    {
        baseUrl: '/playlists',
        label: 'Playlists',
        detailRegex: /\/playlists\/(\d+|create)/,
    },
    {
        baseUrl: '/screens',
        label: 'Screens',
        detailRegex: /\/screens\/(\d+|create)/,
    },
    {
        baseUrl: '/locator',
        label: 'Locator',
    },
    {
        baseUrl: '/installations',
        label: 'Installations',
    },
    {
        baseUrl: '/templates',
        label: 'Templates',
    },
];
